import _ from 'lodash';
import I18nMgmt from 'iceqerp-common/i18n-mgmt';

const i18nMgmt = new I18nMgmt({
  langList: [
    { value: 'en', label: 'English' },
    { value: 'zh-CN', label: '简体中文' }
  ],
  langPackageLoader: {
    load(lang) {
      let promise = null;
      if (lang === 'zh-CN') {
        promise = Promise.all([
          import(/* webpackChunkName: "lang-el-[request]" */'./lang/element-ui/zh-CN'),
          import(/* webpackChunkName: "lang-app-[request]" */'./lang/zh-CN')
        ]);
      } else {
        promise = Promise.all([
          import(/* webpackChunkName: "lang-el-[request]" */'./lang/element-ui/en'),
          import(/* webpackChunkName: "lang-app-[request]" */'./lang/en')
        ]);
      }
      return promise.then(packages => {
        _.assign(packages[0].default, packages[1].default);
        return packages[0].default;
      });
    }
  }
});

export default i18nMgmt;